import textActionTypes from './textActionTypes';
import type { Reducer } from 'types/redux';
import type { CompRef } from 'types/documentServices';
import type { WRichTextSettingsPanelProps } from '#packages/advancedStylePanel';

const {
  OPEN_TEXT_EDITOR,
  CLOSE_TEXT_EDITOR,
  SET_SELECTED_COMPONENT,
  SET_SELECTED_COLOR,
  LOAD_FROM_WIDGET_DESIGN,
  CLEAR_WIDGET_DESIGN_STATE,
  SET_FONT_FAMILY_DROPDOWN_OPENED,
} = textActionTypes;

interface WidgetDesignState {
  selectedComponents: CompRef[];
  panelProps: WRichTextSettingsPanelProps;
}

export interface TextState {
  isLinkPanelOpen: boolean;
  isTextEditorOpen: boolean;
  isFontFamilyDropdownOpen: boolean;
  editStyleOnly: boolean;
  selectedComponent?: CompRef;
  selectedColor?: string;
  widgetDesign?: WidgetDesignState;
  origin: string | null;
}

export const textInitialState: TextState = {
  isTextEditorOpen: false,
  editStyleOnly: false,
  selectedComponent: null,
  selectedColor: null,
  widgetDesign: null,
  isLinkPanelOpen: false,
  isFontFamilyDropdownOpen: false,
  origin: null,
};

export const textReducer: Reducer<TextState> = (
  text = textInitialState,
  action,
) => {
  switch (action.type) {
    case OPEN_TEXT_EDITOR:
      return Object.assign({}, text, {
        isTextEditorOpen: true,
        editStyleOnly: action.editStyleOnly,
        isLinkPanelOpen: action.isLinkPanelOpen,
        origin: action.origin,
      });
    case CLOSE_TEXT_EDITOR:
      return Object.assign({}, text, {
        isTextEditorOpen: false,
        isLinkPanelOpen: false,
        origin: null,
      });
    case SET_SELECTED_COMPONENT:
      return Object.assign({}, text, {
        selectedComponent: action.selectedComponent,
      });
    case SET_SELECTED_COLOR:
      return Object.assign({}, text, {
        selectedColor: action.selectedColor,
      });
    case LOAD_FROM_WIDGET_DESIGN:
      return Object.assign({}, text, {
        selectedComponent: action.selectedComponents[0],
        widgetDesign: {
          selectedComponents: action.selectedComponents,
          panelProps: action.panelProps,
        },
      });
    case CLEAR_WIDGET_DESIGN_STATE:
      return Object.assign({}, text, {
        widgetDesign: {},
        selectedComponent: null,
      });
    case SET_FONT_FAMILY_DROPDOWN_OPENED:
      return Object.assign({}, text, {
        isFontFamilyDropdownOpen: action.isOpen,
      });
    default:
      return text;
  }
};
